// ======== begin: test ==========
// let str = '((12+8)*6)/2';
// let str = '76/10000';
// let result = complexEval(str);
// console.debug(result);
// ======== end: test ==========

export {complexEval}

/**
 * 匹配括号，计算括号内只含加减乘除的表达式
 * @param str
 * @returns {string|string|*}
 */
function complexEval(str) {
    if (str == null) {
        return "";
    }
    if (typeof str != "string") {
        str = str + "";
    }
    let regMatch = /\([^\(\)]+\)/g;
    let multObj = str.match(regMatch);//匹配括号     
    while (null != multObj) {
        let content = multObj[0] + "";
        let result = simpleEval(content.substr(1, content.length - 2));
        str = str.replace(multObj[0], result);
        multObj = str.match(regMatch);
    }
    return simpleEval(str);
}

/**
 * 只有加减乘除表达式的计算, 接受不含括号的的表达式
 * @param str
 * @returns {string|*}
 */
function simpleEval(str) {
    if (str == null) {
        return "";
    }
    if (typeof str != "string") {
        str = str + ""
    }
    let valueArray = [];//值的数组 
    let markArray = [];//符号的数组 
    let tempValue = "";
    let ch = str.split("");
    let isOper = false;
    for (let i = 0; i < ch.length; i++) {
        if (ch[i] === "+" || ch[i] === "-" || ch[i] === "*" || ch[i] === "/") {
            let dv = tempValue * 1;
            if (isOper) {
                let value = valueArray.pop();
                let mark = markArray.pop();
                dv = simpleTwoEval(mark, value, dv);
            }
            valueArray.push(dv);
            markArray.push(ch[i]);
            tempValue = "";
            isOper = ch[i] === "*" || ch[i] === "/";
        } else {
            tempValue += ch[i] + "";
            if (i === ch.length - 1) {
                //最后一位         
                let dv = tempValue * 1;
                if (isOper) {
                    let value = valueArray.pop();
                    let mark = markArray.pop();
                    dv = simpleTwoEval(mark, value, dv);
                }
                valueArray.push(dv);
            }
        }
    }
    valueArray.reverse();
    markArray.reverse();
    while (valueArray.length > 1) {
        let v1 = valueArray.pop();
        let v2 = valueArray.pop();
        let mark = markArray.pop();
        valueArray.push(simpleTwoEval(mark, v1, v2));
    }
    return valueArray[0];
}

/**
 * 两个数的加减乘除，接受运算符号和两个数值
 * @param mark
 * @param value1
 * @param value2
 * @returns {number|*}
 */
function simpleTwoEval(mark, value1, value2) {
    switch (mark) {
        case "+":
            return value1 + value2;
        case "-":
            return value1 - value2;
        case "*":
            return value1 * value2;
        case "/":
            return value1 / value2;
        default:
            return 0;
    }
}

